var _rect, _rect2, _rect3, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71.3252,
    y: 7.20654,
    width: 22.2947,
    height: 174.912,
    rx: 11.1473,
    transform: "rotate(-30.1761 71.3252 7.20654)",
    fill: "#761D96"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.3438,
    y: -3.84473,
    width: 22.7111,
    height: 128.687,
    rx: 11.3556,
    transform: "rotate(30 82.3438 -3.84473)",
    fill: "#742C96"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 133.155,
    width: 22,
    height: 130,
    rx: 11,
    transform: "rotate(90 175 133.155)",
    fill: "#742C96"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 144,
    rx: 11.5,
    ry: 11,
    fill: "#102C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/darkLogo.b652e183ca58fdbd9fe403bcd9881a5a.svg";
export { ForwardRef as ReactComponent };